export default "__VITE_ASSET__CwJ4$_MR__"